import Cookies from 'js-cookie';

export const count = (mainStr = '', char = '') => [...mainStr].filter(l => l === char).length;
export const getDomainMaxThirdLevel = (hostname = 'localhost', domainLevel = 1) => {
  const [topLevel, secondLevel, thirdLevel] = hostname.split('.').reverse();
  switch (domainLevel) {
    case 0:
      return topLevel;
    case 1:
    case 2:
      return `${secondLevel}.${topLevel}`;
    default:
      return `${thirdLevel}.${secondLevel}.${topLevel}`;
  }
};

export const setCookie = (name, value) => {
  const hostname = window.location.hostname;
  const domain = getDomainMaxThirdLevel(hostname, count(hostname, '.'));
  Cookies.set(name, value, { expires: 1, domain, sameSite: 'Strict' });
};

export const getCookie = name => Cookies.getJSON(name) || {};
export const removeCookie = name => Cookies.remove(name);
export const hasStoreCodeBeenSubmittedBefore = ({ storeCode = '', bankId = '' }, brandParam = '') =>
  Boolean(storeCode) && bankId === brandParam;
